import React, { useMemo } from "react";
import style from "./index.module.scss";

import moment from "moment";
import MessageContent from "./Components/MessageContent";
import { ChatMessageItem, MsgType } from "../../../../types";
import { FormatTime, isTrue } from "../../../../polyfills";
import { useAtomValue } from "jotai";
import { userAtom } from "../../../../store";
import { makeSenderFlag } from "../../../../Utils/common";
import classNames from "classnames";
import { useUpdateMessage } from "../../../../Utils/useUpdateMessage";
import { useSender } from "../../../../Utils/useSender";
import { Icon, Modal, notification, Tooltip } from "antd";

interface MessageItemProps {
    index: number;
    sessionId: string;
    message: ChatMessageItem;
    preMessage?: ChatMessageItem;
    onContextMenu(e: any): void;
}

export default function MessageItem({
    index,
    sessionId,
    message,
    preMessage,
    onContextMenu
}: MessageItemProps) {
    const { senderFlag } = useAtomValue(userAtom);

    const sendDate = useMemo(() => {
        if (index === 0) return FormatTime(message.sendDate);

        if (moment(message.sendDate).diff(preMessage?.sendDate, "minute") > 3) {
            return FormatTime(message.sendDate);
        }
        return null;
    }, [message.sendDate]);

    const updateMessage = useUpdateMessage();
    const sender = useSender();

    // 举报
    function onReport() {
        Modal.confirm({
            content: "确定要举报这条消息吗?",
            onOk: async () => {
                try {
                    sender.reportMessage(message);

                    Modal.info({
                        content: "你的举报已经收到，经审核后我们会进行处理。"
                    });

                    updateMessage.updateMessage(
                        message.sessionUid,
                        message.guid,
                        {
                            isAccused: "1"
                        }
                    );
                } catch (e) {
                    notification.info({
                        message: "网络错误, 消息发送失败",
                        placement: "bottomRight"
                    });
                }
            }
        });
    }

    return (
        <div className={style.root} id={message.guid}>
            {sendDate && <div className={style.time}>{sendDate}</div>}

            {makeSenderFlag(message.sender) !== senderFlag && (
                <p className={style.senderName}>
                    {message.sender.name}
                    {!isTrue(message.isAccused) && (
                        <Tooltip title="点击举报">
                            <Icon
                                type="alert"
                                onClick={onReport}
                                className={style.alert}
                            />
                        </Tooltip>
                    )}
                </p>
            )}

            {makeSenderFlag(message.sender) === senderFlag && (
                <p className={style.receivedName}>我</p>
            )}

            <div
                className={classNames(style.message, {
                    [style.fileMessage]: message.type === MsgType.FILE,
                    [style.send]: makeSenderFlag(message.sender) === senderFlag,
                    [style.received]:
                        makeSenderFlag(message.sender) !== senderFlag
                })}>
                <MessageContent
                    sessionId={sessionId}
                    messageId={message.guid}
                    onContextMenu={onContextMenu}
                />
            </div>
        </div>
    );
}
